import { combineReducers, applyMiddleware, createStore } from "redux";
import { thunk } from "redux-thunk";
import InfraReducer from "./pages/Organization/InfraManagement/store/InfraReducer";

let rootReducers = combineReducers({
  infra: InfraReducer,
});

let middleware = [thunk];

export const store = createStore(rootReducers, applyMiddleware(...middleware));
